/** @format */
import {
    AvailableMarket,
    Market,
    MarketCode,
    MarketSlug,
    Operation,
    OperationId,
} from '@toucan/client/global/market';

export const getOperationFromId = (id: number) => {
    const operationKey = OperationId[id] as keyof typeof Operation;
    return Operation[operationKey];
};

export const asMarketCode = (market: string | MarketCode): MarketCode =>
    market.toUpperCase() as MarketCode;

export function getMarketFromCode(
    marketCode: MarketCode,
    availableMarkets: AvailableMarket[]
): AvailableMarket | undefined {
    const market = availableMarkets.find(
        ({ code }) => code.toLowerCase() === marketCode.toLowerCase()
    );

    return market;
}

export function getMarketBySlug(slug: MarketSlug, markets: Market[]) {
    return markets.find((market) => market.slug === slug);
}

export function transformMarketToAvailableMarkets(
    markets: Market[]
): AvailableMarket[] {
    return markets.map(({ code, slug, name, iso, currency, language }) => ({
        code,
        slug,
        name,
        iso,
        currency,
        language,
    }));
}

export function getMarketSlugFromPath(path: string) {
    const [slug] = path.replace(/^\//, '').replace(/\/$/, '').split('/');

    if (!Object.values(MarketSlug).includes(slug as unknown as MarketSlug)) {
        throw Error(`Market slug: ${slug} does not exist in MarketSlug`);
    }

    return slug as unknown as MarketSlug;
}
export function getMarketByCode(marketCode: MarketCode, markets: Market[]) {
    return markets.find(({ code }) => code === marketCode);
}
